import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 340,
        gap: 12,
    },
    noDataIcon: {
        fontSize: 50,
        color: theme.palette.text.primary,
    },
}));
